import colors from "../../base/colors";
import borders from "../../base/borders";

const { white } = colors;
const { borderRadius } = borders;

const tableContainer = {
  styleOverrides: {
    root: {
      backgroundColor: white.main,
      boxShadow: "none",
      border: `1px solid ${colors.grey[300]}`,
      maxWidth: "100%",
      borderRadius: borderRadius.xl,
    },
  },
};

export default tableContainer;
